<template>
  <div v-if="userGuide" class="main-content userGuide-view-page">
    <div class="page-header">
      <h3 class="page-title"> {{ userGuide.name }}</h3>
      <div class="page-actions row">
      </div>
    </div>
    <div class="userGuide-sidebar">
      <div class="side-header">
          <base-input
          v-model="searchData.searchText"
          :placeholder="$t('general.search')"
          input-class="userGu-search"
          icon="search"
          type="text"
          align-icon="right"
          @input="onSearch"
        />
        <div
          class="btn-group ml-3"
          role="group"
          aria-label="First group"
        >
          <base-button v-tooltip.top-center="{ content: getOrderName }" class="userGu-button userGu-filter-sorting-btn" color="default" size="medium" @click="sortData">
            <font-awesome-icon v-if="getOrderBy" icon="sort-amount-up" />
            <font-awesome-icon v-else icon="sort-amount-down" />
          </base-button>
        </div>
      </div>
      <base-loader v-if="isSearching" />
      <div v-else class="side-content">
        <a href="#/"
          v-for="(userGuide,index) in userGuides"
          :to="`/super-admin/user-guides/${userGuide.id}/view`"
          :key="index"
          class="side-userGuide"
          @click="viewUserGuideRoute(userGuide.id)"
        >
          <div class="left">
            <div class="userGu-name">Name: {{ userGuide.name}}</div>
            <div class="userGu-number" v-if="userType == 'super_admin'">Type: {{ userGuide.type }}</div>
            <div class="userGu-number" v-if="userType == 'super_admin'">Status: {{ userGuide.status }}</div>
          </div>
          <div class="right">
            <div class="userGu-date" v-if="userType == 'super_admin'">{{ userGuide.formattedCreatedAt }}</div>
          </div>
        </a>
        <p v-if="!userGuides.length" class="no-result">
          {{ $t('user_guides.no_matching_user_guide') }}
        </p>
      </div>
    </div>
    <div class="userGuide-view-page-container" >
      <iframe :src="`${shareableLink}`" class="frame-style"/>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
const _ = require('lodash')
export default {
  data () {
    return {
      id: null,
      count: null,
      userGuides: [],
      userGuide: null,
      searchData: {
        orderBy: null,
        orderByField: null,
        searchText: null,
      },
      isRequestOnGoing: false,
      isSearching: false,
      userType: null,
    }
  },
  computed: {
    ...mapGetters('userGuide', [
      'viewUserGuide'
    ]),
    getOrderBy () {
      if (this.searchData.orderBy === 'asc' || this.searchData.orderBy == null) {
        return true
      }
      return false
    },
    getOrderName () {
      if (this.getOrderBy) {
        return this.$t('general.ascending')
      }
      return this.$t('general.descending')
    },
    shareableLink () {
      return `/user-guide/pdf/${this.userGuide.unique_hash}`
    }
  },
  watch: {
    $route (to, from) {
      this.loadUserGuide()
    }
  },
  created () {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor';
    }
    else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder';
    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';
    }
    this.loadUserGuides()
    this.loadUserGuide()
    this.onSearch = _.debounce(this.onSearch, 500)
  },
  methods: {
    ...mapActions('userGuide', [
      'fetchUserGuides',
      'fetchUserGuide',
      'searchUserGuide'
    ]),
    async loadUserGuides () {
        let data = {
          orderByField: 'created_at',
          orderBy: 'asc',
        }
        let response = await this.fetchUserGuides(data)
        if (response.data) {
            this.userGuides = response.data.userGuides.data
        }
    },
    async loadUserGuide () {
      if(this.$route.params.id){
        let response
        if(this.userType=='super_admin'){
            response = await this.fetchUserGuide(this.$route.params.id)
        }else if(this.userType=='supplier' && this.$route.name === 'admin-default-userGuide'){
            response = await this.fetchUserGuide(this.viewUserGuide)
        }else if(this.userType=='supplier' && this.$route.name === 'admin-specfic-userGuide'){
            response = await this.fetchUserGuide(this.$route.params.id)
        }else if(this.userType=='anchor' && this.$route.name === 'anchor-default-userGuide'){
            response = await this.fetchUserGuide(this.viewUserGuide)
        }else if(this.userType=='anchor' && this.$route.name === 'anchor-specfic-userGuide'){
            response = await this.fetchUserGuide(this.$route.params.id)
        }else if(this.userType=='funder' && this.$route.name === 'funder-default-userGuide'){
            response = await this.fetchUserGuide(this.viewUserGuide)
        }else if(this.userType=='funder' && this.$route.name === 'funder-specfic-userGuide'){
            response = await this.fetchUserGuide(this.$route.params.id)
        }
        if (response.data) {
            this.userGuide = response.data.userGuide
        }
      }
    },
    async onSearch () {
      let data = ''
      if (this.searchData.searchText !== '' && this.searchData.searchText !== null && this.searchData.searchText !== undefined) {
        data += `search=${this.searchData.searchText}&`
      }
      if (this.searchData.orderBy !== null && this.searchData.orderBy !== undefined) {
        data += `orderBy=${this.searchData.orderBy}&`
      }

      if (this.searchData.orderByField !== null && this.searchData.orderByField !== undefined) {
        data += `orderByField=${this.searchData.orderByField}`
      }
      this.isSearching = true
      let response = await this.searchUserGuide(data)
      this.isSearching = false
      if (response.data) {
        this.userGuides = response.data.userGuides.data
      }
    },
    sortData () {
      if (this.searchData.orderBy === 'asc') {
        this.searchData.orderBy = 'desc'
        this.onSearch()
        return true
      }
      this.searchData.orderBy = 'asc'
      this.onSearch()
      return true
    },
    viewUserGuideRoute(id){
      if(this.userType=='super_admin'){
        this.$router.push(`/super-admin/user-guides/${id}/view`)
      }else if(this.userType=='anchor'){
        this.$router.push(`/anchor/user-guides/${id}/view`)
      }else if(this.userType=='supplier'){
        this.$router.push(`/supplier/user-guides/${id}/view`)
      }else if(this.userType=='funder'){
        this.$router.push(`/funder/user-guides/${id}/view`)
      }
    }
  }
}
</script>
